<template>
    <div>
        <!-- list header -->
        <h2 class="text-center mt-4"
            >{{newsTitle}}</h2>
        <p>{{lang}}share</p>


        <!-- list formating -->
        <ul id="news"
            class="list-group  mt-4">
            <li v-for="news in jsonObjectNews.news"
            class="list-unstyled list-group-item bg-light">
                {{ news.data }} {{news.enInfo}}
        </li>
</ul>
    </div>
</template>

<script>

import jsonObjectNews from './NewsJSON/en-News.json';


export default {
    
    data() {
        return {
            jsonObjectNews,

            newsTitle:jsonObjectNews.newsText.news,
        }
    },



}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/News.vue